import { required, minLength, maxLength } from "react-admin";

export const validateName = [required(), minLength(3), maxLength(40)];
export const requiredField = [required()];
